import React, { useState } from "react";
import "./register.css";
import { useNavigate } from "react-router-dom";
import bg from "../assets/bg.png";
import { backend_url } from "../constants/backend";

function Register() {
  const [form, setForm] = useState({
    Name: "",
    Mobile: "",
    Email: "",
    Company_Name: "",
    Designation: "",
    Ref_by: "",
    References: "",
    Gender: "", // gender field
    Reg_waiver_code: "",

    // ✅ NEW: password fields
    Password: "",
    Confirm_password: "",
  });

  const [photoFile, setPhotoFile] = useState(null); // photo upload

  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showCpass, setShowCpass] = useState(false);

  const navigate = useNavigate();

  const isValidEmail = (email) => {
    const pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return pattern.test(email.trim());
  };

  const isValidMobile = (mobile) => {
    const digits = mobile.replace(/\D/g, "");
    // starts with 6-9 and total 10 digits
    return /^[6-9]\d{9}$/.test(digits);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files && e.target.files[0];
    setPhotoFile(file || null);
  };

  const handleCloseStatus = () => {
    setStatus(null);
  };


  const BYPASS_WAIVER_CODES = ["CCHR", "CCIT"];

const normalizeWaiverCode = (code) => code.trim().toUpperCase();

const shouldBypassWaiverValidation = (code) => {
  return BYPASS_WAIVER_CODES.includes(normalizeWaiverCode(code));
};


const checkWaiverCode = async () => {
  const normalizedCode = normalizeWaiverCode(form.Reg_waiver_code);

  // ✅ BYPASS VALIDATION FOR CCHR / CCIT
  if (shouldBypassWaiverValidation(normalizedCode)) {
    // Update form value to CAPITAL
    setForm((prev) => ({
      ...prev,
      Reg_waiver_code: normalizedCode,
    }));
    return true;
  }

  // ❌ OLD FLOW (API VALIDATION)
  const resp = await fetch(`${backend_url}/validate-waiver-code/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      Reg_waiver_code: normalizedCode,
    }),
  });

  const data = await resp.json();

  if (!resp.ok) {
    setStatus({ success: false, message: data.message });
    return false;
  }

  return true;
};



const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus(null);

  // -------------------------
  // BASIC VALIDATIONS
  // -------------------------
  if (!form.Name.trim()) {
    setStatus({ success: false, message: "Please enter your name." });
    return;
  }

  if (!isValidMobile(form.Mobile)) {
    setStatus({
      success: false,
      message: "Mobile number must be 10 digits and start with 6-9.",
    });
    return;
  }

  if (!isValidEmail(form.Email)) {
    setStatus({
      success: false,
      message: "Please enter a valid email address.",
    });
    return;
  }

  if (!form.Company_Name.trim()) {
    setStatus({ success: false, message: "Company name is required." });
    return;
  }

  if (!form.Designation.trim()) {
    setStatus({ success: false, message: "Designation is required." });
    return;
  }

  if (!form.Password.trim() || !form.Confirm_password.trim()) {
    setStatus({
      success: false,
      message: "Password and Confirm Password are required.",
    });
    return;
  }

  if (form.Password.trim() !== form.Confirm_password.trim()) {
    setStatus({
      success: false,
      message: "Password and Confirm Password must be same.",
    });
    return;
  }

  if (!form.Reg_waiver_code.trim()) {
    setStatus({
      success: false,
      message: "Registration waiver code is required.",
    });
    return;
  }

  setLoading(true);

  try {
    // -------------------------
    // STEP 1: VALIDATE WAIVER CODE (ONLY ONCE)
    // -------------------------
    const isValid = await checkWaiverCode();
    if (!isValid) {
      setLoading(false);
      return;
    }

    // -------------------------
    // STEP 2: PROCEED WITH REGISTRATION
    // -------------------------
    const formData = new FormData();
    formData.append("Name", form.Name.trim());
    formData.append("Mobile", form.Mobile.trim());
    formData.append("Email", form.Email.trim());
    formData.append("Company_Name", form.Company_Name.trim());
    formData.append("Designation", form.Designation.trim());
    formData.append("Ref_by", form.Ref_by.trim());
    formData.append("References", form.References.trim());
    formData.append("Gender", form.Gender);
    formData.append(
  "Reg_waiver_code",
  normalizeWaiverCode(form.Reg_waiver_code)
);


    if (photoFile) {
      formData.append("Photo", photoFile);
    }

    formData.append("Password", form.Password.trim());
    formData.append("Confirm_password", form.Confirm_password.trim());

    const registerResp = await fetch(`${backend_url}/register/`, {
      method: "POST",
      body: formData,
    });

    if (registerResp.ok) {
      sessionStorage.setItem("registeredEmail", form.Email.trim());
      navigate("/award", { state: { email: form.Email.trim() } });
    } else {
      const data = await registerResp.json().catch(() => ({}));
      setStatus({
        success: false,
        message: data.detail || "Server error",
      });
    }
  } catch (err) {
    setStatus({
      success: false,
      message: "Network error: " + String(err),
    });
  } finally {
    setLoading(false);
  }
};



  // Show popup ONLY when it is an error AND message contains "email"
  const shouldShowPopup =
    status &&
    !status.success &&
    typeof status.message === "string" &&
    status.message.toLowerCase().includes("email");

  return (
    <>
      {/* Popup overlay for "email" related errors */}
      {shouldShowPopup && (
        <div className="popup-overlay" onClick={handleCloseStatus}>
          <div
            className="popup"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="popup-title">Error</div>
            <div className="popup-message">{status.message}</div>
            <button
              type="button"
              className="popup-btn"
              onClick={handleCloseStatus}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* ✅ OUTER WRAPPER WITH BACKGROUND IMAGE */}
      <div
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* ✅ INNER FORM AREA KEEPS OLD BACKGROUND FROM register.css */}
        <div
          className="register-container"
          style={{
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <div className="register-card">
            <div className="form-left">
              <form
                onSubmit={handleSubmit}
                noValidate
                style={{
                  backgroundColor: "#0f172a",
                  borderRadius: "12px",
                  padding: "7px",
                  marginTop: "130px",
                }}
              >
                <h2>Register YourSelf</h2>
                <div className="form-grid">
                  <div className="form-row">
                    <label htmlFor="name" style={{ fontWeight: "bold" }}>
                      Name *
                    </label>
                    <input
                      id="name"
                      name="Name"
                      value={form.Name}
                      onChange={handleChange}
                      placeholder="Full name"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="mobile" style={{ fontWeight: "bold" }}>
                      Mobile Number *
                    </label>
                    <input
                      id="mobile"
                      name="Mobile"
                      value={form.Mobile}
                      onChange={handleChange}
                      placeholder="Enter your number"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="email" style={{ fontWeight: "bold" }}>
                      Email *
                    </label>
                    <input
                      id="email"
                      name="Email"
                      type="email"
                      value={form.Email}
                      onChange={handleChange}
                      placeholder="name@example.com"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="gender" style={{ fontWeight: "bold" }}>
                      Gender
                    </label>
                    <select
                      id="gender"
                      name="Gender"
                      value={form.Gender}
                      onChange={handleChange}
                    >
                      <option value="">Select gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>

                  <div className="form-row">
                    <label htmlFor="company" style={{ fontWeight: "bold" }}>
                      Company Name *
                    </label>
                    <input
                      id="company"
                      name="Company_Name"
                      value={form.Company_Name}
                      onChange={handleChange}
                      placeholder="Company name"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label
                      htmlFor="designation"
                      style={{ fontWeight: "bold" }}
                    >
                      Designation *
                    </label>
                    <input
                      id="designation"
                      name="Designation"
                      value={form.Designation}
                      onChange={handleChange}
                      placeholder="e.g. IT HR / HR"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="photo" style={{ fontWeight: "bold" }}>
                      Upload Photo
                    </label>
                    <input
                      id="photo"
                      name="Photo"
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoChange}
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="ref_by" style={{ fontWeight: "bold" }}>
                      Refered By
                    </label>
                    <input
                      id="ref_by"
                      name="Ref_by"
                      value={form.Ref_by}
                      onChange={handleChange}
                      placeholder="Who referred you?"
                    />
                  </div>

                  <div className="form-row">
                    <label
                      htmlFor="references"
                      style={{ fontWeight: "bold" }}
                    >
                      References
                    </label>
                    <input
                      id="references"
                      name="References"
                      value={form.References}
                      onChange={handleChange}
                      placeholder="Name / Mobile Number"
                    />
                  </div>

                  <div className="form-row">
                    <label htmlFor="Reg_waiver_code" style={{ fontWeight: "bold" }}>
                      Registration Waiver Code *
                    </label>

                    <input
                      id="Reg_waiver_code"
                      name="Reg_waiver_code"
                      value={form.Reg_waiver_code}
                      onChange={handleChange}
                      placeholder="Enter the code"
                    />

                   
                  </div>

                  {/* PASSWORD FIELD */}
                  <div className="form-row" style={{ position: "relative" }}>
                    <label htmlFor="password" style={{ fontWeight: "bold" }}>
                      Password *
                    </label>

                    <input
                      id="password"
                      name="Password"
                      type={showPass ? "text" : "password"}
                      value={form.Password}
                      onChange={handleChange}
                      placeholder="Enter password"
                      required
                    />

                    {/* SVG ICON TOGGLE */}
                    <span
                      onClick={() => setShowPass(!showPass)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "32px",
                        cursor: "pointer",
                        color: "black",
                        width: "22px",
                        height: "22px",
                        userSelect: "none",
                      }}
                    >
                      {showPass ? (
                        /* 👁‍🗨 EYE SLASH */
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.359 11.238 3.28 1.16 2.22 2.22l2.088 2.088A7.027 7.027 0 0 0 1.173 8c1.276 3.063 4.045 5 6.827 5 1.318 0 2.627-.33 3.82-.987l2.18 2.18 1.06-1.06-1.701-1.895zM8 11c-1.657 0-3-1.343-3-3 0-.53.133-1.03.366-1.47l4.104 4.104A2.984 2.984 0 0 1 8 11zm6.827-3c-.636 1.527-1.707 2.79-3.064 3.668l-1.453-1.453A4.978 4.978 0 0 0 13 8c0-1.513-.671-2.862-1.74-3.746L10.116 5.4c.559.572.884 1.33.884 2.1 0 .53-.133 1.03-.366 1.47L13.827 8z" />
                        </svg>
                      ) : (
                        /* 👁 EYE ICON */
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 3C4.5 3 1.534 5.09.173 8c1.36 2.91 4.327 5 7.827 5s6.467-2.09 7.827-5C14.467 5.09 11.5 3 8 3zm0 9c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                        </svg>
                      )}
                    </span>
                  </div>

                  {/* CONFIRM PASSWORD FIELD */}
                  <div className="form-row" style={{ position: "relative" }}>
                    <label
                      htmlFor="confirm_password"
                      style={{ fontWeight: "bold" }}
                    >
                      Confirm Password *
                    </label>

                    <input
                      id="confirm_password"
                      name="Confirm_password"
                      type={showCpass ? "text" : "password"}
                      value={form.Confirm_password}
                      onChange={handleChange}
                      placeholder="Re-enter password"
                      required
                    />

                    {/* SVG ICON TOGGLE */}
                    <span
                      onClick={() => setShowCpass(!showCpass)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "32px",
                        cursor: "pointer",
                        color: "black",
                        width: "22px",
                        height: "22px",
                        userSelect: "none",
                      }}
                    >
                      {showCpass ? (
                        /* EYE SLASH */
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M13.359 11.238 3.28 1.16 2.22 2.22l2.088 2.088A7.027 7.027 0 0 0 1.173 8c1.276 3.063 4.045 5 6.827 5 1.318 0 2.627-.33 3.82-.987l2.18 2.18 1.06-1.06-1.701-1.895zM8 11c-1.657 0-3-1.343-3-3 0-.53.133-1.03.366-1.47l4.104 4.104A2.984 2.984 0 0 1 8 11zm6.827-3c-.636 1.527-1.707 2.79-3.064 3.668l-1.453-1.453A4.978 4.978 0 0 0 13 8c0-1.513-.671-2.862-1.74-3.746L10.116 5.4c.559.572.884 1.33.884 2.1 0 .53-.133 1.03-.366 1.47L13.827 8z" />
                        </svg>
                      ) : (
                        /* EYE */
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 3C4.5 3 1.534 5.09.173 8c1.36 2.91 4.327 5 7.827 5s6.467-2.09 7.827-5C14.467 5.09 11.5 3 8 3zm0 9c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
                        </svg>
                      )}
                    </span>
                  </div>
                </div>

                <div className="form-actions">
                  <button
                    className="btn"
                    type="submit"
                    style={{ width: "210px" }}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Submit"}
                  </button>

                  {/* Show inline status ONLY if not using popup */}
                  {status && !shouldShowPopup && (
                    <div
                      className="form-status"
                      role="status"
                      aria-live="polite"
                    >
                      <div
                        className={`status ${
                          status.success ? "status-success" : "status-error"
                        }`}
                      >
                        {status.message}
                      </div>
                    </div>
                  )}
                </div>

                {/* ✅ Already registered? Login */}
                <div
                  style={{
                    marginTop: "16px",
                    textAlign: "center",
                    marginBottom: "8px",
                  }}
                >
                  <p style={{ color: "white" }}>
                    Already registered?
                    <span
                      style={{
                        color: "#00eaff",
                        marginLeft: "6px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                      onClick={() => navigate("/")}
                    >
                      Login
                    </span>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
